import { KeyRound } from 'lucide-react';
import { PluginIcon } from '@reflex/ui/components/shared/PluginIcon';
import { ConfigBadge } from '@/components/status/ConfigBadge';
import { SECRET_SOURCE_BADGE } from '@/lib/status-colors';
import type { SecretSource } from '@/lib/types';

export function IntegrationIcon({ icon }: { icon?: string }) {
  return (
    <PluginIcon
      icon={icon}
      size="sm"
      fallbackIcon={<KeyRound className="h-4 w-4 text-muted-foreground" />}
    />
  );
}

export function StatusBadge({ source }: { source: SecretSource }) {
  return <ConfigBadge config={SECRET_SOURCE_BADGE} value={source} />;
}
